import { ReactNode, Suspense } from "react";
import { Fallback } from "./Fallback";

export const MySuspense = ({ children }: { children: ReactNode }) => (
  <Suspense fallback={<Fallback />}>{children}</Suspense>
);
